import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import type { Note } from "@/services/api";
import type { NoteEditorFormValues, NoteEditorProps } from "@/features/NoteEditor/model";
import type { FC } from "react";
import { PersonSelect } from "../../PersonSelect";
import { TypeSelect } from "../../TypeSelect";
import { StatusSelect } from "../../StatusSelect";
import { TextInput } from "../../TextInput";
import { Files } from "../../Files";
import { TitleInput } from "../../TitleInput";
import { DueDateSelect } from "../../DueDateSelect";
import { DateSelect } from "../../DateSelect";
import { DirectionSelect } from "../../DirectionSelect";
import { ImportantFlag } from "../../ImportantFlag";
import styles from "./styles.module.scss";

type Props = {
  deleteNoteFileById: NoteEditorProps["deleteNoteFileById"];
};

export const MobileContent: FC<Props> = ({ deleteNoteFileById = () => "" }) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<NoteEditorFormValues>();
  const currentNote = watch("currentNote");
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles["header-row"]}>
          <PersonSelect />
          <TypeSelect />
        </div>
        <div className={styles["header-row"]}>
          {currentNote?.noteType?.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT && (
            <DirectionSelect />
          )}
          {(currentNote?.noteType?.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT ||
            currentNote?.noteType?.name === DEFAULT_NOTE_TYPES.DEFAULT_IDEA) && <StatusSelect />}
        </div>
        <div className={classNames(styles["header-row"], styles["note-dates"])}>
          <DateSelect />
          {currentNote?.noteType?.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT && (
            <>
              <p className={styles["due-name"]}>{t("notesPage.due")}</p>
              <DueDateSelect />
            </>
          )}
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.title}>
          <ImportantFlag />
          <TitleInput />
        </div>
        <div className={styles.files}>
          {currentNote?.text && currentNote.personId && (
            <Files
              onFileDelete={(file: Note["attachments"][number]) => {
                deleteNoteFileById({ file: file, noteId: currentNote?.id ?? "" });
              }}
              mobile={true}
            />
          )}
        </div>
        <div className={styles.text}>
          <TextInput />
        </div>
      </div>
    </div>
  );
};
